import React from 'react';
import classNames from 'classnames/bind';
import { apiBaseUrls } from '@saucelabs/sl-util-config';

import AutomatedTestsTutorialVideo from '../Onboarding/AutomatedTests/TutorialVideo';
import Styles from './EmptyState.styles';

const context = classNames.bind(Styles);

const AutomatedJobsEmptyState = () => (
  <div className={context('automated-jobs')}>
    <div className={context('video')}>
      <AutomatedTestsTutorialVideo />
    </div>
    <div className={context('url-change')}>
      <h4>Already using Selenium Grid locally?</h4>
      <p>{"If you're already testing with a Selenium grid locally, all you've got to do to point your tests to Sauce is change the address of your Selenium Server."}</p>
      <div className={context('change-flow')}>
        <span className={context('url', 'local-url')}>localhost:4444</span>
        <span className={context('jobs-onboarding-arrow')}>&#x279d;</span>
        <span className={context('url', 'remote-url')}>{`https://${apiBaseUrls.ondemand}`}</span>
      </div>
    </div>
  </div>
);

export default AutomatedJobsEmptyState;
